import { AppLayout } from '../components/AppLayout';
import { AdminRoute } from '../components/ProtectedRoute';

export default [AdminRoute, AppLayout];
